import React, { Component,Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Digital_add_pro extends Component {
    constructor(props) {
        super(props)
        this.state = {
            category: {},
            status: '',
        }
        this.submitHandler = this.submitHandler.bind(this)
    }

    componentDidMount(){
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }
        
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        // alert(lastItem)
        fetch(`${process.env['REACT_APP_HOST']}/api/parentcategories/${lastItem}`)
        .then((response) => response.json()) 
            .then(result => {
                console.log(result)
            this.setState({ category: result });
        });
    }

    submitHandler(e){
        e.preventDefault();
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        const url = `${process.env['REACT_APP_HOST']}/api/parentcategories/${lastItem}`;
		const params = {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
                name: e.target.name.value,
                status: this.state.status
			}),
		};
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                toast.success(data)
                // window.location.reload(); 
            })
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Edit Parent Category" parent="Digital" />
                <ToastContainer />
                <div className="container-fluid">
                    <div className="row product-adding">
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-body">
                                    <form method="post" action="" onSubmit={this.submitHandler}>
                                        <div className="digital-add needs-validation">
                                        
                                            <div className="form-group">
                                                <label className="col-form-label pt-0"><span>*</span> Name</label>
                                                <input type="text" defaultValue={this.state.category.name} name="name" className="form-control" required="required" ></input>
                                                <input type="hidden" name="parentId" value="0" />
                                            </div>
                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span>Status</label>
                                                <select className="custom-select" name="status" value={this.state.status} onChange={(e) => this.setState({ status:e.target.value })} >
                                                    <option value="1">Enable</option>
                                                    <option value="0">Disable</option>
                                                </select>
                                            </div>
                                            
                                            <br></br>
                                            <div className="form-group mb-0">
                                                <div className="product-buttons">
                                                    {/* <button type="submit" className="btn btn-primary">Update</button> */}
                                                    <input type="submit" name="submit" value="Update" className="btn btn-primary" />
                                                    {/* <button type="button" className="btn btn-light">Discard</button> */}
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Digital_add_pro
